import dayjs from 'dayjs';

export default ({ userDate, years }) => {
  return dayjs(new Date()).subtract(years, 'year').isAfter(userDate);
};
